import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { AnalyticsFetchActiveDateRangeResponse } from 'src/services/__generated__/api'

const getActiveDateRange =
  async (): Promise<AnalyticsFetchActiveDateRangeResponse> => {
    const { data } =
      await AnalyticsApi.v1Private.analyticsFetchActiveDateRangeList()

    return data
  }

export const useGetActiveDateRangeQuery = () => {
  return useQuery({
    queryFn: () => getActiveDateRange(),
    queryKey: [QueryKey.ACTIVE_DATE_RANGE],
  })
}
